module.exports = __webpack_public_path__ + "img/bg_avatar_female_95.142b3f62.png";